/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
};

export enum BillingFrequency {
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type Checkout = {
  __typename?: 'Checkout';
  url: Scalars['String'];
};

export type ContentBlock = {
  __typename?: 'ContentBlock';
  content: Scalars['String'];
  data?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  discountFormatted: Scalars['String'];
  endTime?: Maybe<Scalars['ISO8601DateTime']>;
  name: Scalars['String'];
};

export type Hero = {
  __typename?: 'Hero';
  author: Scalars['String'];
  badgeTitle?: Maybe<Scalars['String']>;
  explicit: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  mediaUrl: Scalars['String'];
  metadata: Array<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a new user */
  userCreate?: Maybe<UserCreatePayload>;
  /** Creates a new user */
  userSignIn?: Maybe<UserSignInPayload>;
  /** Unlinks a user's Spotify account */
  userUnlinkSpotify?: Maybe<UserUnlinkSpotifyPayload>;
};


export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


export type MutationUserSignInArgs = {
  input: UserSignInInput;
};


export type MutationUserUnlinkSpotifyArgs = {
  input: UserUnlinkSpotifyInput;
};

export type Page = {
  __typename?: 'Page';
  contentBlocks: Array<ContentBlock>;
  hero: Hero;
  language: Scalars['String'];
  product?: Maybe<Product>;
};

export type PlaybackOption = {
  __typename?: 'PlaybackOption';
  icon: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type Price = {
  __typename?: 'Price';
  currency: Scalars['String'];
  displayPrice: Scalars['String'];
  price: Scalars['Float'];
};

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<ContentBlock>>;
  name: Scalars['String'];
  promotion?: Maybe<Promotion>;
  purchaseOptions: Array<PurchaseOption>;
  shows: Array<Show>;
};

export type Promotion = {
  __typename?: 'Promotion';
  amountOff?: Maybe<Scalars['Float']>;
  code: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  duration: Scalars['Int'];
  name: Scalars['String'];
  percentOff?: Maybe<Scalars['Int']>;
};

export type PurchaseOption = {
  __typename?: 'PurchaseOption';
  billingFrequency: BillingFrequency;
  checkoutUrl: Scalars['String'];
  displayPrice: Scalars['String'];
  identifier: Scalars['String'];
  name: Scalars['String'];
  price: Price;
  startDate: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  trialDays?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  checkout: Checkout;
  page?: Maybe<Page>;
  show: Show;
  subscription?: Maybe<Subscription>;
  user?: Maybe<User>;
  userVerify?: Maybe<Session>;
};


export type QueryCheckoutArgs = {
  productId: Scalars['String'];
  token: Scalars['String'];
};


export type QueryPageArgs = {
  promoCode?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryShowArgs = {
  slug: Scalars['String'];
};


export type QuerySubscriptionArgs = {
  resourceId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  token: Scalars['String'];
};


export type QueryUserArgs = {
  token: Scalars['String'];
};


export type QueryUserVerifyArgs = {
  slug?: InputMaybe<Scalars['String']>;
  verificationCode: Scalars['String'];
};

export type Session = {
  __typename?: 'Session';
  authToken: Scalars['String'];
  email: Scalars['String'];
  subscription?: Maybe<Subscription>;
};

export type Show = {
  __typename?: 'Show';
  author: Scalars['String'];
  category: Scalars['String'];
  coverImageUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  episodeCount: Scalars['Int'];
  explicit: Scalars['Boolean'];
  id: Scalars['ID'];
  playbackOptions: Array<PlaybackOption>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  cancelAt?: Maybe<Scalars['ISO8601DateTime']>;
  discount?: Maybe<Discount>;
  id: Scalars['String'];
  lastPayment: Scalars['ISO8601DateTime'];
  manageUrl: Scalars['String'];
  nextBillingAt?: Maybe<Scalars['ISO8601DateTime']>;
  premiumUserEmail?: Maybe<Scalars['String']>;
  product: Product;
  purchaseOption: PurchaseOption;
  reference: Scalars['String'];
  shows: Array<Show>;
  spotifyConnected: Scalars['Boolean'];
  status: SubscriptionStatus;
  trialPeriodEndsAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  InTrial = 'IN_TRIAL'
}

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  name: Scalars['String'];
  subscriptions?: Maybe<Array<Subscription>>;
};

/** Autogenerated input type of UserCreate */
export type UserCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  paymentOptionId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UserCreate. */
export type UserCreatePayload = {
  __typename?: 'UserCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: Scalars['String'];
  session?: Maybe<Session>;
};

/** Autogenerated input type of UserSignIn */
export type UserSignInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  slug: Scalars['String'];
};

/** Autogenerated return type of UserSignIn. */
export type UserSignInPayload = {
  __typename?: 'UserSignInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: Scalars['String'];
};

/** Autogenerated input type of UserUnlinkSpotify */
export type UserUnlinkSpotifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** Autogenerated return type of UserUnlinkSpotify. */
export type UserUnlinkSpotifyPayload = {
  __typename?: 'UserUnlinkSpotifyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: Scalars['String'];
};

export type PageQueryVariables = Exact<{
  slug: Scalars['String'];
  resourceId?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', language: string, hero: { __typename?: 'Hero', author: string, badgeTitle?: string | null, explicit: boolean, iconUrl?: string | null, mediaUrl: string, subtitle?: string | null, title: string, metadata: Array<string> }, contentBlocks: Array<{ __typename?: 'ContentBlock', content: string, title?: string | null, data?: string | null, type: string }>, product?: { __typename?: 'Product', name: string, description?: string | null, promotion?: { __typename?: 'Promotion', name: string, description: string, code: string, percentOff?: number | null, duration: number, amountOff?: number | null, currency?: string | null } | null, shows: Array<{ __typename?: 'Show', title: string, coverImageUrl?: string | null }>, features?: Array<{ __typename?: 'ContentBlock', content: string, type: string, data?: string | null }> | null, purchaseOptions: Array<{ __typename?: 'PurchaseOption', billingFrequency: BillingFrequency, checkoutUrl: string, trialDays?: number | null, startDate: string, displayPrice: string, name: string, identifier: string, price: { __typename?: 'Price', price: number, currency: string, displayPrice: string } }> } | null } | null };

export type Create_UserMutationVariables = Exact<{
  email: Scalars['String'];
  paymentOptionId?: InputMaybe<Scalars['String']>;
}>;


export type Create_UserMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'UserCreatePayload', result: string, session?: { __typename?: 'Session', email: string, authToken: string } | null } | null };

export type User_Unlink_SpotifyMutationVariables = Exact<{
  authToken: Scalars['String'];
}>;


export type User_Unlink_SpotifyMutation = { __typename?: 'Mutation', userUnlinkSpotify?: { __typename?: 'UserUnlinkSpotifyPayload', result: string } | null };

export type Get_User_VerifyQueryVariables = Exact<{
  code: Scalars['String'];
  slug: Scalars['String'];
}>;


export type Get_User_VerifyQuery = { __typename?: 'Query', userVerify?: { __typename?: 'Session', email: string, authToken: string, subscription?: { __typename?: 'Subscription', id: string } | null } | null };

export type Get_SubscriptionQueryVariables = Exact<{
  authToken: Scalars['String'];
  slug: Scalars['String'];
  resourceId?: InputMaybe<Scalars['String']>;
}>;


export type Get_SubscriptionQuery = { __typename?: 'Query', subscription?: { __typename?: 'Subscription', id: string, lastPayment: any, nextBillingAt?: any | null, trialPeriodEndsAt?: any | null, cancelAt?: any | null, spotifyConnected: boolean, reference: string, status: SubscriptionStatus, manageUrl: string, premiumUserEmail?: string | null, product: { __typename?: 'Product', name: string, shows: Array<{ __typename?: 'Show', title: string, coverImageUrl?: string | null, subtitle?: string | null, explicit: boolean, playbackOptions: Array<{ __typename?: 'PlaybackOption', icon: string, name: string, url: string }> }> }, discount?: { __typename?: 'Discount', name: string, endTime?: any | null, discountFormatted: string } | null, purchaseOption: { __typename?: 'PurchaseOption', name: string, trialDays?: number | null, billingFrequency: BillingFrequency, price: { __typename?: 'Price', price: number, currency: string } } } | null };

export type Signin_UserMutationVariables = Exact<{
  email: Scalars['String'];
  slug: Scalars['String'];
}>;


export type Signin_UserMutation = { __typename?: 'Mutation', userSignIn?: { __typename?: 'UserSignInPayload', result: string } | null };


export const PageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"page"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"resourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"promoCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"badgeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"explicit"}},{"kind":"Field","name":{"kind":"Name","value":"iconUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentBlocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"checkoutUrl"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"displayPrice"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"displayPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PageQuery, PageQueryVariables>;
export const Create_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_USER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentOptionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"paymentOptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentOptionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"authToken"}}]}}]}}]}}]} as unknown as DocumentNode<Create_UserMutation, Create_UserMutationVariables>;
export const User_Unlink_SpotifyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"USER_UNLINK_SPOTIFY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUnlinkSpotify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authToken"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<User_Unlink_SpotifyMutation, User_Unlink_SpotifyMutationVariables>;
export const Get_User_VerifyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_USER_VERIFY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userVerify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"verificationCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"authToken"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Get_User_VerifyQuery, Get_User_VerifyQueryVariables>;
export const Get_SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_SUBSCRIPTION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"resourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastPayment"}},{"kind":"Field","name":{"kind":"Name","value":"nextBillingAt"}},{"kind":"Field","name":{"kind":"Name","value":"trialPeriodEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAt"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyConnected"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"manageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"premiumUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"coverImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"explicit"}},{"kind":"Field","name":{"kind":"Name","value":"playbackOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"discountFormatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}},{"kind":"Field","name":{"kind":"Name","value":"billingFrequency"}}]}}]}}]}}]} as unknown as DocumentNode<Get_SubscriptionQuery, Get_SubscriptionQueryVariables>;
export const Signin_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SIGNIN_USER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSignIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<Signin_UserMutation, Signin_UserMutationVariables>;